import { render, staticRenderFns } from "./OverWeightFemale.vue?vue&type=template&id=ca63c25c&scoped=true&"
import script from "./OverWeightFemale.vue?vue&type=script&lang=js&"
export * from "./OverWeightFemale.vue?vue&type=script&lang=js&"
import style0 from "./OverWeightFemale.vue?vue&type=style&index=0&id=ca63c25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca63c25c",
  null
  
)

export default component.exports